<template>
	<div class="portal-ad">
		<!-- <el-header class="userQueryHeader" height="32px">
			<div class="userQueryHeader-wrap"><span>cms栏目管理</span></div>
		</el-header> -->
		<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
			<el-menu-item index="1">栏目管理</el-menu-item>
			<el-menu-item index="2">添加栏目</el-menu-item>
		</el-menu>
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'cmsColumn',
	data() {
		return {
			activeIndex: '1'
		};
	},
	watch: {
		$route(to) {
			switch (to.path) {
				case '/cmsColumn/Column':
					this.activeIndex = '1';
					break;
				case '/cmsColumn/AddColumn':
					this.activeIndex = '2';
					break;
				default:
					this.activeIndex = '1';
					break;
			}
		}
	},
	mounted() {
		this.handleSelect();
	},
	methods: {
		handleSelect(value) {
			switch (value) {
				case '1':
					this.$router.push({ name: 'Column' });
					break;
				case '2':
					this.$router.push({ name: 'AddColumn' });
					break;
				default:
					this.$router.push({ name: 'Column' });
					break;
			}
		}
	}
};
</script>

<style lang="scss">
.portal-ad {
	height: calc(100vh - 100px);
	.userQueryHeader {
		background: #f4f8fc;
		box-shadow: 0px -2px 3px rgba($color: #e7e7e7, $alpha: 0.5) inset;
		span {
			font-size: 12px;
			line-height: 32px;
			padding: 0 2px;
		}
		&-wrap {
			span {
				padding-left: 7px;
				border-left: 3px solid #3394e1;
				color: rgba(2, 21, 37, 0.45);
			}
		}
	}
}
</style>